<template>
    <div>
        <Menu mode="vertical" active-name="Data" width="auto" @on-select="selectMenu">
            <MenuItem name="Data">
                <font-awesome-icon :icon="['fas','database']" size="sm" class="icon-menu"/>
            </MenuItem>
<!--            <MenuItem name="Directory">-->
<!--                <font-awesome-icon :icon="['fas','folder-open']" size="sm"  class="icon-menu"/>-->
<!--            </MenuItem>-->
            <MenuItem name="Directory">
                <font-awesome-icon :icon="['fas','stream']" size="sm"  class="icon-menu"/>
            </MenuItem>
        </Menu>
    </div>
</template>
<script>
    // import {mapMutations, mapState} from "vuex";
    export default {
        name:"left",
        props:{
            selectMenu:Function,
            current:String
        },
        methods:{
        },
        created(){
            // this.getContestInfo()
        }
    }
</script>
<style scoped>
    .icon-menu{
        margin:0 auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
</style>
